import { AxiosResponse } from "axios";
import { AxiosService } from "./axios.service";

export interface LocationResponse {
  places: string[];
  status: string;
}

export interface LocationCoordinates {
  lat: number;
  lng: number;
}

export interface DistanceTimeRequest {
  start: LocationCoordinates;
  end: LocationCoordinates;
}

export interface DistanceTimeResponse {
  distance: number; // in meters (raw Google Maps API response)
  duration: number; // in seconds
}

export class LocationService {
  private static instance: LocationService;
  private axiosService = AxiosService.getInstance();

  private constructor() {}

  public static getInstance(): LocationService {
    if (!LocationService.instance) {
      LocationService.instance = new LocationService();
    }
    return LocationService.instance;
  }
  
  getLocation(location: string): Promise<AxiosResponse<LocationResponse>> {
    const url = `/gmaps/autocomplete?place=${location}`;
    return this.axiosService.get<LocationResponse>(url, {});
  }

  getDistanceTime(request: DistanceTimeRequest, token: string): Promise<AxiosResponse<DistanceTimeResponse>> {
    const url = `/gmaps/distance-time`;
    return this.axiosService.postWithToken<DistanceTimeResponse>(url, request, token);
  }
}
